// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1821":"02d68c67cfe1c2aa","2864":"41572191ee774d53","4004":"b9d18c7c4c0eeb6c"}[chunkId] + ".css";
};